document.documentElement.classList.remove('no-js');

const navToggle = document.querySelector('[data-nav-toggle]');
const nav = document.querySelector('[data-nav]');
if (navToggle && nav) {
  navToggle.addEventListener('click', () => {
    const open = navToggle.getAttribute('aria-expanded') === 'true';
    navToggle.setAttribute('aria-expanded', String(!open));
    nav.classList.toggle('is-open', !open);
  });
}

document.querySelectorAll('[data-product]').forEach((root) => {
  const variantsNode = root.querySelector('[data-variants]');
  const variantInput = root.querySelector('[data-variant-id]');
  const optionSelects = [...root.querySelectorAll('[data-option]')];
  if (!variantsNode || !variantInput || !optionSelects.length) return;
  const variants = JSON.parse(variantsNode.textContent);
  const updateVariant = () => {
    const selected = optionSelects.map((select) => select.value);
    const variant = variants.find((item) => item.options.every((option, index) => option === selected[index]));
    if (variant) variantInput.value = variant.id;
  };
  optionSelects.forEach((select) => select.addEventListener('change', updateVariant));
});
